<div class="d-flex flex-column p-3 upload-image-container">
  <div class="d-flex flex-row align-items-center justify-content-between">
    <h2>Foto Ulasan</h2>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <input #file id="file-upload" type="file" (change)="onFileSelected($event)" accept="image/png, image/jpeg"
         multiple/>

  <ng-container *ngIf="data.filename; else upload">
    <div class="d-flex flex-column">
      <div class="my-3 image-preview">
        <img [ngSrc]="imageTmpEndpoint+data.filename" fill="contain" [alt]="data.filename"/>
      </div>
      <div class="d-flex flex-column">
        <button mat-flat-button class="btn-base btn-edit-image mb-2" (click)="onEditImage(data.filename);file.click()">
          <mat-icon>edit</mat-icon>
          Ubah Foto
        </button>
        <button mat-flat-button class="btn-base btn-delete-image" (click)="onDeleteImage(data.filename)">
          <mat-icon>delete_outline</mat-icon>
          Delete
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #upload>
    <div class="d-flex flex-column">
      <div class="image-preview my-3" *ngIf="imagePreviews.length > 0">
        <img [src]="imagePreviews[0]" fill="contain" [alt]="data.filename"/>
      </div>
      <label for="file-upload" class="custom-file-upload mb-3">
        Pilih Foto <span *ngIf="imagePreviews && imagePreviews.length > 0"> ({{ imagePreviews.length }} terpilih)</span>
      </label>

      <mat-error *ngIf="errorMessage" class="text-sm my-2">{{ errorMessage }}</mat-error>

      <ng-container *ngIf="progressUpload | async as progress">
        <button
          mat-raised-button
          color="primary"
          class="btn-base btn-upload-image"
          [disabled]="selectedFiles.length < 1 || errorMessage || progress < 100"
          (click)="uploadImage()">
          Unggah Foto
        </button>
        <mat-progress-bar *ngIf="progress < 100" mode="determinate" [value]="progress"></mat-progress-bar>
      </ng-container>
    </div>
  </ng-template>

</div>
